import type { JSX } from "react";
import type { Mode } from "@/types/roast";
import { cn } from "@/lib/utils";

export function ModeToggle({
  mode,
  onChange,
}: {
  mode: Mode;
  onChange: (m: Mode) => void;
}): JSX.Element {
  return (
    <div className="inline-flex rounded-full border border-border p-1">
      <button
        type="button"
        aria-pressed={mode === "roast"}
        onClick={() => onChange("roast")}
        className={cn(
          "px-4 py-1.5 text-sm font-semibold rounded-full transition-colors",
          mode === "roast" ? "text-white" : "text-muted-foreground",
        )}
        style={mode === "roast" ? { backgroundColor: "#E62D23" } : undefined}
      >
        Roast
      </button>
      <button
        type="button"
        aria-pressed={mode === "toast"}
        onClick={() => onChange("toast")}
        className={cn(
          "px-4 py-1.5 text-sm font-semibold rounded-full transition-colors",
          mode === "toast" ? "text-white" : "text-muted-foreground",
        )}
        style={mode === "toast" ? { backgroundColor: "#5382FF" } : undefined}
      >
        Toast
      </button>
    </div>
  );
}
